import React, { useEffect, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  useQueryGetUserDocumentStatus,
  useQueryGetUserInfo,
} from "../../hooks/react-query/useData";
import axios from "axios";
import toast from "react-hot-toast";
import { CircularProgress } from "@mui/material";

const CompanyInfo = () => {
  const { data: userDocumentStatus, refetch: refetchUserDocumentStatus } =
    useQueryGetUserDocumentStatus();
  const { data: allUserInfo, refetch } = useQueryGetUserInfo();

  const [firstAcceptedFiles, setFirstAcceptedFiles] = useState([]);
  const [secondAcceptedFiles, setSecondAcceptedFiles] = useState([]);
  const [isFirstLoading, setIsFirstLoading] = useState(false);
  const [isSecondLoading, setIsSecondLoading] = useState(false);

  const [companyData, setCompanyData] = useState([]);
  const [secondFileStatus, setSecondFileStatus] = useState(true);

  //commenting because we don't need the dropbox to be controlled by the API's response and adding default value to the states
  // useEffect(() => {
  //   if (userDocumentStatus?.data?.data?.count === 0) {
  //     setFirstFileStatus(true);
  //     setSecondFileStatus(true);
  //   } else if (userDocumentStatus?.data?.data?.count === 1) {
  //     setFirstFileStatus(false);
  //     setSecondFileStatus(true);
  //   } else if (userDocumentStatus?.data?.data?.count === 2) {
  //     setFirstFileStatus(false);
  //     setSecondFileStatus(false);
  //   }
  // }, [userDocumentStatus]);
  useEffect(() => {
    fetchCompanyData();
  }, []);

  const fetchCompanyData = async () => {
    // setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/user-company-detail`,

        {
          headers: {
            Authorization: `Token ${localStorage.getItem("auth_token")}`,
          },
        }
      );
      setCompanyData(response?.data?.data);
      refetch();
    } catch (error) {
      toast.error("No tienes permiso para subir archivos");
    } finally {
      // setLoading(false);
    }
  };

  // useEffect(() => {
  //   refetchUserDocumentStatus();

  //   if (firstAcceptedFiles.length > 0) {
  //     handleUploadFile(
  //       firstAcceptedFiles[0],
  //       setIsFirstLoading,
  //       refetchUserDocumentStatus
  //     );
  //     setFirstAcceptedFiles([]);
  //   }
  // }, [firstAcceptedFiles]);

  // useEffect(() => {
  //   refetchUserDocumentStatus();

  //   if (secondAcceptedFiles.length > 0) {
  //     handleUploadFile(
  //       secondAcceptedFiles[0],
  //       setIsSecondLoading,
  //       refetchUserDocumentStatus
  //     );
  //     setSecondAcceptedFiles([]);
  //   }
  // }, [secondAcceptedFiles]);

  // const {
  //   getRootProps: getFirstRootProps,
  //   getInputProps: getFirstInputProps,
  //   isFocused: isFirstFocused,
  //   isDragAccept: isFirstDragAccept,
  //   isDragReject: isFirstDragReject,
  // } = useDropzone({
  //   accept: {
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
  //       ".xlsx",
  //     ],
  //   },
  //   multiple: false,
  //   onDrop: (acceptedFiles) => setFirstAcceptedFiles(acceptedFiles),
  // });

  // const {
  //   getRootProps: getSecondRootProps,
  //   getInputProps: getSecondInputProps,
  //   isFocused: isSecondFocused,
  //   isDragAccept: isSecondDragAccept,
  //   isDragReject: isSecondDragReject,
  // } = useDropzone({
  //   accept: {
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
  //       ".xlsx",
  //     ],
  //   },
  //   multiple: false,

  //   onDrop: (acceptedFiles) => setSecondAcceptedFiles(acceptedFiles),
  // });

  // const baseStyle = {
  //   flex: 1,
  //   display: "flex",
  //   flexDirection: "column",
  //   alignItems: "center",
  //   padding: "40px",
  //   margin: "20px 95px",
  //   borderWidth: 2,
  //   borderRadius: "12px",
  //   borderColor: "grey",
  //   backgroundColor: "white",
  //   borderStyle: "dashed",
  //   backgroundColor: "#fafafa",
  //   color: "#bdbdbd",
  //   outline: "none",
  //   transition: "border .24s ease-in-out",
  // };

  // const focusedStyle = {
  //   borderColor: "#2196f3",
  // };

  // const acceptStyle = {
  //   borderColor: "#00e676",
  // };

  // const rejectStyle = {
  //   borderColor: "#ff1744",
  // };

  // const firstStyle = useMemo(
  //   () => ({
  //     ...baseStyle,
  //     ...(isFirstFocused ? focusedStyle : {}),
  //     ...(isFirstDragAccept ? acceptStyle : {}),
  //     ...(isFirstDragReject ? rejectStyle : {}),
  //   }),
  //   [isFirstFocused, isFirstDragAccept, isFirstDragReject]
  // );

  // const secondStyle = useMemo(
  //   () => ({
  //     ...baseStyle,
  //     ...(isSecondFocused ? focusedStyle : {}),
  //     ...(isSecondDragAccept ? acceptStyle : {}),
  //     ...(isSecondDragReject ? rejectStyle : {}),
  //   }),
  //   [isSecondFocused, isSecondDragAccept, isSecondDragReject]
  // );

  return (
    <div className="main-container">
      <div>
        <img
          src={companyData?.logo}
          alt="Company Logo"
          style={{ width: "150px", height: "150px", margin: "20px 20px 20px 9%" }}
          className="company-logo"
        />
      </div>
      {/* --- Datos de la Empresa --- */}
      <div
        style={{
          borderBottom: "2px solid #80808033",
          padding: "1%  9%",
          fontSize: "22px",
          fontWeight: "bold",
        }}
      >
        <>Datos de la Empresa</>
      </div>

      <div
        className="input-container"
        style={{ marginTop: "20px", flexWrap: "wrap" }}
      >
        <div className="input-group" style={{ width: "40%" }}>
          <p>Nombre de la empresa</p>
          <input
            className="company-info-inputs"
            type="text"
            value={companyData?.name || ""}
            readOnly
          />
        </div>

        <div className="input-group" style={{ width: "40%" }}>
          <p>Sector económico</p>
          <input
            className="company-info-inputs"
            type="text"
            value={companyData?.economic_sector || ""}
            readOnly
          />
        </div>

        <div className="input-group" style={{ width: "40%" }}>
          <p>Ciudad</p>
          <input
            className="company-info-inputs"
            type="text"
            value={companyData?.office_city || ""}
            readOnly
          />
        </div>

        <div className="input-group" style={{ width: "40%" }}>
          <p>Dirección</p>
          <input
            className="company-info-inputs"
            type="text"
            value={companyData?.address || ""}
            readOnly
          />
        </div>

        <div className="input-group" style={{ width: "20%" }}>
          <p>Teléfono</p>
          <input
            className="company-info-inputs"
            type="text"
            value={companyData?.phone_number || ""}
            readOnly
          />
        </div>

        <div className="input-group" style={{ width: "18%" }}>
          <p>NIT</p>
          <input
            className="company-info-inputs"
            type="text"
            value={companyData?.nit || ""}
            readOnly
          />
        </div>
        <div className="input-group" style={{ width: "40%" }}>
          <p>URL Página web</p>
          <input
            className="company-info-inputs"
            type="text"
            placeholder="www."
            value={companyData?.website || ""}
            readOnly
          />
        </div>
      </div>

      {/* --- Datos del Área Responsable --- */}
      <div
        style={{
          borderBottom: "2px solid #80808033",
          padding: "1%  9%",
          fontSize: "22px",
          fontWeight: "bold",
        }}
      >
        <>Datos del Área Responsable</>
      </div>

      <div
        style={{
          padding: "2% 0 0 9%",
          fontSize: "14px",
        }}
      >
        <>Información del área responsable</>
      </div>

      <div
        className="input-container"
        style={{ marginTop: "20px", flexWrap: "wrap" }}
      >
        <div className="input-group" style={{ width: "40%" }}>
          <p>Área</p>
          <input
            className="company-info-inputs"
            type="text"
            value={companyData?.responsible_area || ""}
            readOnly
          />
          <p>Cargo</p>
          <input
            className="company-info-inputs"
            type="text"
            value={companyData?.person_incharge_position || ""}
            readOnly
          />
          <p>Correo corporativo</p>
          <input
            className="company-info-inputs"
            type="email"
            value={companyData?.person_incharge_email || ""}
            readOnly
          />
        </div>

        <div className="input-group" style={{ width: "40%" }}>
          <p>Nombre completo de quien diligencia</p>
          <input
            className="company-info-inputs"
            type="text"
            value={companyData?.person_incharge || ""}
            readOnly
          />
          <p>Teléfono</p>
          <input
            className="company-info-inputs"
            type="text"
            value={companyData?.phone_number || ""}
            readOnly
          />
        </div>
      </div>

      {/* --- Información del líder del área --- */}
      <div
        style={{
          padding: "0 0 0 9%",
          fontSize: "14px",
        }}
      >
        <>Información del líder del área</>
      </div>

      <div
        className="input-container"
        style={{ marginTop: "20px", flexWrap: "wrap", marginBottom: "5%" }}
      >
        <div className="input-group" style={{ width: "40%" }}>
          <p>Líder del área</p>
          <input
            className="company-info-inputs"
            type="text"
            value={companyData?.area_manager || ""}
            readOnly
          />
          <p>Teléfono</p>
          <input
            className="company-info-inputs"
            type="text"
            value={companyData?.phone_number || ""}
            readOnly
          />
        </div>

        <div className="input-group" style={{ width: "40%" }}>
          <p>Cargo</p>
          <input
            className="company-info-inputs"
            type="text"
            value={companyData?.person_incharge_position || ""}
            readOnly
          />
          <p>Correo corporativo</p>
          <input
            className="company-info-inputs"
            type="email"
            value={companyData?.manager_email || ""}
            readOnly
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyInfo;
